<template>
<m-pageframe
    :title="title"
>
<v-container
    v-if="unavailable_settings != null"
>

    <v-text-field
        label="Organization"
        :value="endpoint_profile.organization_label"
        disabled
        readonly
        autocomplete="off"
    />

    <v-text-field
        label="Phone Number"
        :value="$rc.pretty(endpoint_profile.endpoint)"
        disabled
        readonly
        autocomplete="off"
    />

    <v-text-field
        label="Label"
        :value="endpoint_profile.label"
        disabled
        readonly
        autocomplete="off"
    />

    <v-text-field
        label="Assignment"
        :value="endpoint_profile.assignment_label"
        disabled
        readonly
        autocomplete="off"
    /> 

    <v-switch
        label="Send Auto Response Outside of Available Hours"
        v-model="unavailable_settings.enabled"
        v-on:change="put"
    />

    <b>Available Hours ({{available_timezone}})</b>

    <m-daily-schedule
        v-model="unavailable_settings.schedule_available"
        :read_only="false"
        v-on:input="put"
    />

    <m-edit-message-patterns
        v-model="unavailable_settings.patterns"
        context="endpoint-unavailable-auto-response"
        v-on:input="put"
    />


</v-container>
</m-pageframe>
</template>

<script>

const _ = require('lodash');

export default {
    data() {
        return {
            endpoint_profile: null,
            unavailable_settings: null,
            available_timezone: null,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET: /numbers/endpoint-unavailable-auto-response/:organization_id/:endpoint',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                    'endpoint' : this.$route.params.endpoint,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.endpoint_profile = data.endpoint_profile;
                    this.unavailable_settings = data.unavailable_settings;
                    this.available_timezone = data.available_timezone;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        put: _.debounce(function()
        {
            this.$rc.rest(
                'PUT: /numbers/endpoint-unavailable-auto-response',
            
                this.unavailable_settings,
            
                (data) => {
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete save changes');
                },
            );

        },500),
    },

    computed: {
        title() {
            let ep = this.endpoint_profile;

            if ( ep == null ) 
                return 'Unavailable Auto Response';

            return 'Unavailable Auto Response: '+ep.label;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>